import * as React from 'react';
import {
  Toolbar,
  Button,
} from '@progress/kendo-react-buttons';
import { Switch, Input, InputChangeEvent, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import {useEffect} from "react";
import {BaseEvent} from "@progress/kendo-react-common";
import {UploadAddEvent} from "../interfaces/FileManagerModels";
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Upload } from '@progress/kendo-react-upload';

export const FileManagerToolbar = (props) => {
  const [searchValue, setSearchValue] = React.useState(null);
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [dialogVisible, setDialogVisible] = React.useState<boolean>(false);

    const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0 && props.onFilesSelected) {
            props.onFilesSelected(files);
        }
    };

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleDialogVisibility = (event: BaseEvent<Dialog> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setDialogVisible(!dialogVisible);
    };

    const handleFileChange = (event: UploadAddEvent) => {
        props.onFileChange({
            files: event.newState,
            event: event
        });
    };

    const handleUploadClearList = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        props.onClearFileList(event);
    };

    const handleUploadDone = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setDialogVisible(!dialogVisible);
        props.onUploadComplete(event);
    };

    useEffect(() => {
        setSearchValue('')
    }, [props.selectedTreeItem])
  const handleSearchChange = (event: InputChangeEvent) => {
    setSearchValue(event.value)
    props.onSearchChange(event);
  };

  const handleSwitchChange = (event: SwitchChangeEvent) => {
    props.onSwitchChange(event);
  };

  const handleNewFolderClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    props.onNewFolderClick(event);
  }

  const handleDownloadClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    props.handleDownloadClick(event);
  }

  return (
      <Toolbar className="k-filemanager-toolbar">
          <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              multiple
              onChange={handleFileInputChange}
          />
          {/*<Button disabled={!props.selectedTreeItem?.allowfolder} onClick={handleNewFolderClick}>New Folder</Button>*/}
          {/*<Button disabled={!props.selectedTreeItem?.allowupload} onClick={handleUploadClick}>Upload</Button>*/}
          {dialogVisible &&
              <Dialog
                  title={'Upload Files'}
                  className={'k-filemanager-upload-dialog'}
                  onClose={handleDialogVisibility}
                  contentStyle={{ width: '530px' }}
              >
                  <Upload
                      batch={false}
                      multiple={true}
                      files={props.files}
                      withCredentials={false}
                      onAdd={handleFileChange}
                      onRemove={handleFileChange}
                      onProgress={handleFileChange}
                      onStatusChange={handleFileChange}
                      saveUrl={'https://demos.telerik.com/kendo-ui/service-v4/upload/save'}
                      removeUrl={'https://demos.telerik.com/kendo-ui/service-v4/upload/remove'}
                  />
                  <DialogActionsBar layout={'end'}>
                      <Button onClick={handleUploadClearList} > Clear List</Button>
                      <Button themeColor={'primary'} onClick={handleUploadDone}> Done </Button>
                  </DialogActionsBar>
              </Dialog >
          }

        <Button disabled={!props.selectedTreeItem?.allowfolder} onClick={handleNewFolderClick}>New Folder</Button>
        <Button disabled={!props.selectedTreeItem?.allowupload} onClick={handleUploadClick}>Upload</Button>
        <Button disabled={Object.keys(props.gridSelection)?.length == 0} onClick={handleDownloadClick}>Download</Button>


        <div className="k-filemanager-search-tool k-textbox k-toolbar-last-visible" >
          <Input style={{minWidth: '200px'}} type={'search'} className="k-input" value={searchValue} placeholder="Search" onChange={handleSearchChange} />
          {props.searchData &&
              <div style={{marginLeft: '10px'}} className="k-input-icon">{props.searchData?.length} Results</div>
          }
        </div>
        <div className="k-spacer">&nbsp;</div>
        <div className="k-filemanager-details-toggle">
          <Label>View Details </Label>
          <Switch defaultChecked={true} onChange={handleSwitchChange} />
        </div>

      </Toolbar>
  );
}
